export const SupportedLanguages = [
    {
        display: 'i18n.english',
        code: 'en'
    },
    {
        display: 'i18n.japan',
        code: 'ja'
    }
];

export interface ILanguage {
    display: string;
    code: string;
}
